import React from 'react';
import { TooltipHtml } from '../tooltip/tooltip.Html';

export const BOARD_TOOLBOX_BASE_BTN_CLASS =
  'cursor-pointer transition hover:opacity-50 rounded flex items-center justify-center leading-none appearance-none bg-transparent border-0 p-0 m-0';

export const BoardToolboxActionButton = ({
  title,
  active = false,
  onClick,
  onContextMenu,
  children,
  className = '',
}) => {
  const resolvedClassName = `${BOARD_TOOLBOX_BASE_BTN_CLASS} ${
    active ? 'text-secondary' : 'text-contrast'
  } ${className}`.trim();

  return (
    <TooltipHtml title={title}>
      <button
        type='button'
        className={resolvedClassName}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        {children}
      </button>
    </TooltipHtml>
  );
};

export const BoardToolboxToolButton = ({
  title,
  tool,
  activeTool = 'select',
  onToolChange,
  onContextMenu,
  inactiveTool = 'select',
  children,
  className = '',
}) => (
  <BoardToolboxActionButton
    title={title}
    active={activeTool === tool}
    onClick={() => onToolChange?.(activeTool === tool ? inactiveTool : tool)}
    onContextMenu={onContextMenu}
    className={className}
  >
    {children}
  </BoardToolboxActionButton>
);
